import React from 'react';
import styled from 'styled-components';
import { DefaultPalette, Slider, Stack, IStackStyles, IStackTokens } from '@fluentui/react';

const itemStyles = {
    alignItems: 'center',
    background: '#f2f2f2',
    height: '150px',
    width: '400px',
    justifyContent: 'center',
};

const stackStyles = {
    root: {
        width: `100%`
    },
};

const stackWrapperStyles = {
    backgroundColor: `#000000`,
    height: `100vh`
};

const Title = styled.div`
    width: 100%;
    text-align: center;
    margin-top: 20px;
    font-weight: bold;
`;

const Emotion = styled.div`
    width: 100%;
    text-align: center;
    margin-top: 20px;
`;

const EmotionNormalStyles = {
    fontSize: '60px',
    color: '#B9B9B9'
};

const EmotionActiveStyles = {
    fontSize: '60px',
    color: '#31e0a9',
    backgroundColor: '#21B472',
    borderRadius: '5px'
};

class Overview extends React.Component {

    render() {
        return (
            <span style={itemStyles}>
                <Title>ความพึงพอใจภาพรวมต่อการบริหารแหล่งท่องเที่ยวพื้นที่นาเกลือ</Title>
                <Emotion>
                    <span class="material-icons" style={EmotionNormalStyles}>mood_bad</span>
                    <span class="material-icons" style={EmotionNormalStyles}>sentiment_very_dissatisfied</span>
                    <span class="material-icons" style={EmotionNormalStyles}>sentiment_satisfied</span>
                    <span class="material-icons" style={EmotionNormalStyles}>sentiment_satisfied_alt</span>
                    <span class="material-icons" style={EmotionActiveStyles}>sentiment_very_satisfied</span>
                </Emotion>
            </span>
        );
    }
}

export default Overview;